import React, { useContext } from 'react';
import { __extends, __assign } from 'tslib';
import { isSharedLayout, SharedLayoutContext, FramerTreeLayoutContext } from '../../../context/SharedLayoutContext.js';
/**
 * This component is responsible for scheduling the measuring of the motion component
 */

var Measure =
/** @class */
function (_super) {
  __extends(Measure, _super);

  function Measure() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * If this is a child of a SyncContext, register the VisualElement with it on mount.
   */


  Measure.prototype.componentDidMount = function () {
    var _a = this.props,
        syncLayout = _a.syncLayout,
        framerSyncLayout = _a.framerSyncLayout,
        visualElement = _a.visualElement;
    isSharedLayout(syncLayout) && syncLayout.register(visualElement);
    isSharedLayout(framerSyncLayout) && framerSyncLayout.register(visualElement);
  };
  /**
   * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
   * handle the snapshotting.
   *
   * If it is stand-alone component, add it to the batcher.
   */


  Measure.prototype.getSnapshotBeforeUpdate = function () {
    var _a = this.props,
        syncLayout = _a.syncLayout,
        visualElement = _a.visualElement;

    if (isSharedLayout(syncLayout)) {
      syncLayout.syncUpdate();
    } else {
      visualElement.snapshotViewportBox();
      syncLayout.add(visualElement);
    }

    return null;
  };

  Measure.prototype.componentDidUpdate = function () {
    var _a = this.props,
        syncLayout = _a.syncLayout,
        visualElement = _a.visualElement;
    if (!isSharedLayout(syncLayout)) syncLayout.flush();
    /**
     * If this axis isn't animating as a result of this render we want to reset the targetBox
     * to the measured box
     */

    visualElement.rebaseProjectionTarget();
  };

  Measure.prototype.render = function () {
    return null;
  };

  return Measure;
}(React.Component);

function MeasureContextProvider(props) {
  var syncLayout = useContext(SharedLayoutContext);
  var framerSyncLayout = useContext(FramerTreeLayoutContext);
  return React.createElement(Measure, __assign({}, props, {
    syncLayout: syncLayout,
    framerSyncLayout: framerSyncLayout
  }));
}

var MeasureLayout = {
  key: "measure-layout",
  shouldRender: function shouldRender(props) {
    return !!props.drag || !!props.layout || props.layoutId !== undefined;
  },
  getComponent: function getComponent() {
    return MeasureContextProvider;
  }
};
export { MeasureLayout };